import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import { Grid } from "@material-ui/core";
import styles from "../online/OnlineTradeIn.module.scss";
import CheckBox from "../../../shared/checkBox/CheckBox";
import ValuationDialog from "../dialogs/valuationDialog/ValuationDialog";
import HasPermissionTo from "../../../common/HasPermissionTo";
import CustomerReservationsClient from "../../../shared/clients/CustomerReservationsClient";
import CapitalizeText from "../../../utils/CapitalizeText";
import SharedToolTip from "../../../shared/sharedToolTip/SharedToolTip";
import { NOTNULL_OR_NOTUNDEFINED } from "../../../utils/EmpUtil";

class OfflineTradeIn extends Component {
  constructor(props) {
    super(props);
    this.state = {
      openDialog: false,
      tooltipOneOpen: false,
      tooltipTwoOpen: false,
    };

    this.canViewTradeIn =
      this.props.user.permissions.rolePermissions.hasOwnProperty(
        "tradeIn:view"
      );

    this.canWriteTradeIn =
      this.props.user.permissions.rolePermissions.hasOwnProperty(
        "tradeIn:write"
      );
  }
  handleSaveValuation = (expiryDate, valuationAmount) => {
    this.props.hideOrShow(true);
    CustomerReservationsClient.saveValuation({
      user: this.props.user,
      expiryDate: expiryDate,
      valuationAmount: valuationAmount,
      orderId: this.props.tradeInDetails.orderId,
      appraisalId: this.props.tradeInDetails.appraisalId,
      isOnlineTradeIn: false,
    })
      .then(() => {
        this.props.refreshOrderDetails();
      })
      .catch(() => {
        this.props.showErrorPopup(
          this.props.t("Error.processingErrorTitle"),
          this.props.t("Error.processingErrorMessage")
        );
      })
      .finally(() => {
        this.props.hideOrShow(false);
        this.closeDialog();
      });
  };

  openDialog = () => this.setState({ openDialog: true });

  closeDialog = () => this.setState({ openDialog: false });

  toggleTooltipOne = () => {
    this.setState((prevState) => ({
      tooltipOneOpen: !prevState.tooltipOneOpen,
    }));
  };

  toggleTooltipTwo = () => {
    this.setState((prevState) => ({
      tooltipTwoOpen: !prevState.tooltipTwoOpen,
    }));
  };
  getTooltip(infoVersion) {
    return infoVersion === 1 ? (
      <div className={styles.tooltip} data-testid="valuation-tooltip">
        <SharedToolTip
          className={styles.tooltip}
          open={this.state.tooltipOneOpen}
          closeTooltip={this.toggleTooltipOne}
          openTooltip={this.toggleTooltipOne}
          title={this.props.t("DealerDashboard.tradeIn")}
          body={this.getTooltipBody()}
        />
      </div>
    ) : (
      <div className={styles.tooltip}>
        <SharedToolTip
          className={styles.tooltip}
          open={this.state.tooltipTwoOpen}
          closeTooltip={this.toggleTooltipTwo}
          openTooltip={this.toggleTooltipTwo}
          title={this.props.t("DealerDashboard.tradeIn")}
          body={this.getTooltipBody()}
        />
      </div>
    );
  }

  getTooltipBody() {
    return (
      <div>
        <div>
          {this.props.t("TradeIn.setBy")}: {this.props.tradeInDetails.userId}
        </div>
        <div>
          {this.props.t("TradeIn.date")}:{" "}
          {this.props.tradeInDetails.acceptedDate}
        </div>
      </div>
    );
  }
  render() {
    const { tradeInDetails } = this.props;
    const GridItem = ({ label, value, edit, info, infoVersion }) => {
      return (
        <Grid item xs={3}>
          <div className={styles.gridItem}>
            <span className={styles.label}>
              {label}
              {edit && (
                <button
                  data-testid="edit-valuation"
                  className={styles.linkButton}
                  onClick={this.props.openDialogEdit}
                >
                  {this.props.t("DealerVehicles.edit")}
                </button>
              )}
            </span>
            <span className={styles.value}>
              {this.props.parseBoolean(value) || "-"}
              {info && this.getTooltip(infoVersion)}
            </span>
          </div>
        </Grid>
      );
    };
    return (
      <div className={styles.tradeInWrapper}>
        <span className={styles.subHeader}>
          {this.props.t("TradeIn.vehicleDetails")}
        </span>
        <Grid container>
          <GridItem
            label={this.props.t("TradeIn.registrationDate")}
            value={
              tradeInDetails.vehicleRegistrationDate &&
              tradeInDetails.vehicleRegistrationDate.substring(0, 10)
            }
          />

          <GridItem
            label={this.props.t("TradeIn.make")}
            value={tradeInDetails.vehicleMake}
          />

          <GridItem
            label={this.props.t("TradeIn.model")}
            value={tradeInDetails.vehicleModel}
          />

          {this.canViewTradeIn && (
            <GridItem
              label={
                CapitalizeText(this.props.t("TradeIn.outstandingFinance")) + ":"
              }
              value={this.props.outstandingFinance}
              edit={this.canWriteTradeIn && !this.props.handOverComplete}
              info={NOTNULL_OR_NOTUNDEFINED(this.props.tradeInDetails.userId)}
              infoVersion={2}
            />
          )}
        </Grid>

        <Grid container>
          <GridItem
            label={this.props.t("TradeIn.fuelType")}
            value={tradeInDetails.fuelType}
          />

          <GridItem
            label={this.props.t("TradeIn.vehicleMileage")}
            value={tradeInDetails.mileage}
          />

          <GridItem
            label={this.props.t("TradeIn.vehicleCondition")}
            value={tradeInDetails.overallCondition}
          />

          {this.canViewTradeIn && (
            <GridItem
              label={this.props.t("TradeIn.tradeInValuation")}
              value={this.props.appraisalAmount}
              edit={this.canWriteTradeIn && !this.props.handOverComplete}
              info={NOTNULL_OR_NOTUNDEFINED(this.props.tradeInDetails.userId)}
              infoVersion={1}
            />
          )}
        </Grid>

        {!this.canViewTradeIn && (
          <>
            <div className={styles.checkBoxPadding}>
              <HasPermissionTo
                perform={["tradeIn:write"]}
                permissions={this.props.user.permissions.rolePermissions}
                render={() => (
                  <CheckBox
                    id="offline-trade-in"
                    checked={
                      this.props.appraisalAmount || this.state.openDialog
                    }
                    isDisabled={tradeInDetails.expiryDate}
                    label={this.props.t("TradeIn.valuation")}
                    onChange={this.openDialog}
                    textClass={styles.checkBox}
                  />
                )}
                noRender={() => (
                  <CheckBox
                    id="offline-trade-in"
                    checked={tradeInDetails.expiryDate}
                    isDisabled={true}
                    label={this.props.t("TradeIn.valuation")}
                    textClass={styles.checkBox}
                  />
                )}
              />
            </div>

            <ValuationDialog
              open={this.state.openDialog}
              close={this.closeDialog}
              saveValuation={this.handleSaveValuation}
            />

            {tradeInDetails && tradeInDetails.expiryDate && (
              <div className={styles.valuationInfoWrapper}>
                <span className={styles.valuationAcceptedDate}>
                  {tradeInDetails.acceptedDate}
                </span>
                {/*<span>{tradeInDetails.acceptedDate}</span>*/}
                <div className={styles.valuationInfo}>
                  <div className={styles.valuationInfoRow}>
                    <span className={styles.valuationInfoLabel}>
                      {this.props.t("TradeIn.setBy")}
                    </span>
                    <span className={styles.valuationInfoValue}>
                      &nbsp;- {tradeInDetails.userId}
                    </span>
                  </div>
                  <div className={styles.valuationInfoRow}>
                    <span className={styles.valuationInfoLabel}>
                      {this.props.t("TradeIn.amount")}
                    </span>
                    <span className={styles.valuationInfoValue}>
                      &nbsp;- {this.props.appraisalAmount}
                    </span>
                  </div>
                  <div className={styles.valuationInfoRow}>
                    <span className={styles.valuationInfoLabel}>
                      {this.props.t("TradeIn.expiryDate")}
                    </span>
                    <span className={styles.valuationInfoValue}>
                      &nbsp;- {tradeInDetails.expiryDate}
                    </span>
                  </div>
                </div>
              </div>
            )}
          </>
        )}
      </div>
    );
  }
}

export default withTranslation("emp")(OfflineTradeIn);
